import each from 'lodash-es/each';

export default () => {
  document.querySelectorAll('[data-store-hours]').forEach((el) => {
    if (el.getAttribute('initialized') === 'true') {
      return;
    }

    el.setAttribute('initialized', 'true');

    const dataStr = el.getAttribute('data-store-hours');
    const data = JSON.parse(decodeURIComponent(dataStr.replace(/\+/g, ' ')));

    each(data, (item) => {
      const str = `
        <div class="StoreDetail__hours-item">
          <b>${item.day}</b> ${item.hours}
        </div>
      `;
      el.insertAdjacentHTML('beforeend', str);
    });
  });
};
